import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerCertificationModalComponent } from './historical-customer-certification-modal.component';
import { HistoricalCustomerCertificationComponent } from './historical-customer-certification.component';

@NgModule({
    declarations: [
        HistoricalCustomerCertificationComponent,
        HistoricalCustomerCertificationModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerCertificationComponent,
        HistoricalCustomerCertificationModalComponent
    ]
})

export class HistoricalCustomerCertificationModule { }
